"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleSwitch = void 0;
var React = require("react");
var Theme_1 = require("../../Theme");
var Localization_1 = require("./../../Localization");
var ToggleSwitch_styles_1 = require("./ToggleSwitch.styles");
var ToggleSwitch = /** @class */ (function (_super) {
    __extends(ToggleSwitch, _super);
    function ToggleSwitch(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (e) {
            e.stopPropagation();
            _this.toggleCheck();
        };
        _this.state = ({ Checked: _this.props.Value });
        _this.toggleCheck = _this.toggleCheck.bind(_this);
        return _this;
    }
    ToggleSwitch.prototype.UNSAFE_componentWillReceiveProps = function (props) {
        if (this.state.Checked !== props.Value) {
            this.setState({ Checked: props.Value });
        }
    };
    ToggleSwitch.prototype.render = function () {
        var colorTheme = this.state.Checked ? Theme_1.Color.Green.Dark : Theme_1.Color.Grey.Light;
        var checkboxStyle = __assign(__assign({}, colorTheme), { justifyContent: this.state.Checked ? "flex-start" : "flex-end" });
        var knobPosition = {
            left: this.state.Checked ? "26px" : "2px",
        };
        return (React.createElement(ToggleSwitch_styles_1.Button, { "aria-label": this.state.Checked ? Localization_1.strings.ToggleSwitch_Label_Enabled : Localization_1.strings.ToggleSwitch_Label_Disabled, type: "button", disabled: this.props.Disabled, style: checkboxStyle, onClick: this.handleClick },
            React.createElement(ToggleSwitch_styles_1.Caption, null, this.state.Checked ? Localization_1.strings.ToggleSwitch_Label_On : Localization_1.strings.ToggleSwitch_Label_Off),
            React.createElement(ToggleSwitch_styles_1.Knob, { style: knobPosition })));
    };
    ToggleSwitch.prototype.toggleCheck = function () {
        var _this = this;
        var value = !this.state.Checked;
        this.setState({ Checked: value }, function () {
            if (_this.props.OnChange) {
                _this.props.OnChange(value);
            }
        });
    };
    return ToggleSwitch;
}(React.PureComponent));
exports.ToggleSwitch = ToggleSwitch;
